if (!customElements.get('free-gift')) {

  class FreeGift extends HTMLElement {

    constructor() {
      super();

      // Options
      this.options = {
        "threshold": 2500,
        "max_gifts": 1
      }

      // Get options from element data and combine with this.options
      if (this?.dataset?.options) {
        const dataOptions = parseJson(this.dataset.options);
        this.options = {
          ...this.options,
          ...dataOptions
        };
      }

      // selectors
      this.selectors = {
        content: document.querySelector('[data-free-gift-content]'),
        cartItems: document.querySelector('cart-items'),
        cartDrawer: document.querySelector('cart-drawer')
      }

      // set initial state for animations
      if (this.options.cart_total) {
        let timeout = this.selectors.cartDrawer ? 1000 : 100
        setTimeout(() => {
          this.update({
            total_price: this.options.cart_total
          });
        }, timeout);
      }

    }

    /**
     * Update the progress bar
     * @param state {object}: state object received from cart update (cart.js)
     */
    update(state) {

      // get total price from state
      const { total_price } = state;

      if ( this.options.threshold < total_price ) {
        this.style.height = `${this.selectors.content.offsetHeight}px`;
        this.classList.remove('free-gift--hidden');
        // Select first gift if non is selected
        if (!document.querySelector('[data-free-gift-item]:checked')) {
          document.querySelector('[data-free-gift-item]').checked = true;
          this.updateGift(document.querySelector('[data-free-gift-item]').getAttribute('data-free-gift-item'), true);
        }
      } else {
        this.style.height = "0px";
        this.classList.add('free-gift--hidden');
        this.updateGift(null, false);
      }

    }


    /**
     * Sections to render after cart/donation update
     * @returns {object}
     */
    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-cart-item-contents',
        },
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-cart-bubble-contents',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-cart-footer-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '[data-cart-icon-bubble]',
        }
      ];
    }

    /**
     * Get section Inner html
     * @param {string} html
     * @param {string} selector
     * @returns DOM
     */
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    /**
     * Add gift product to the cart
     * @param {string} id: variant id received from cart update (cart.js), if null remove all
     * @param {boolean} add: true or false
     */
    updateGift(id, add = true) {
      if (!id && add == true) {
        return false;
      }

      return new Promise((resolve, reject)=>{
        try {

          (async () => {

            // Add loader
            document.querySelector('cart-items').enableLoading();

            // Variables
            let sections;
            id = parseFloat(id);

            // Get all cart information
            let cart = await fetch(`${routes.cart_url}`, {...fetchConfig()});
                cart = await cart.json();

            // Current gift items form cart
            let currentGiftItem = cart.items.filter((item) => (item.properties._free_gift == true && item.id == id)),
                otherGiftItems = cart.items.filter((item) => (item.properties._free_gift == true && item.id != id)),
                maxOtherGiftItems = (add ? this.options.max_gifts - 1 : this.options.max_gifts),
                count_free_gifts = 0;

            // If no id and adding == false remove all gift items
            if (!id && !add) {
              maxOtherGiftItems = 0;
            }

            // Capture update items
            let updateItems = {},
                disableItems = [];

            if (currentGiftItem.length >= 1) {
              updateItems[`${currentGiftItem[0].key}`] = (add ? 1 : 0);
            }

            otherGiftItems.forEach((item, index) => {
              if (index >= maxOtherGiftItems) {
                updateItems[`${item.key}`] = 0;
                disableItems.push(item);
              } else {
                count_free_gifts++;
              }
            });

            // Set free gift attribute (null = no free gifts, true is x free gifts)
            let free_gift_attribute = count_free_gifts >= 1 ? true : null,
                update_attribute = false;

            if (free_gift_attribute == null && typeof cart.attributes['free-gift'] != 'undefined') {
              update_attribute = true;

            } else if (free_gift_attribute && typeof cart.attributes['free-gift'] != 'string') {
              update_attribute = true;
            }

            // Update UI Disable free gifts if needed (will be removed with update fetch)
            disableItems.forEach((item) => {
              let giftCartItem = document.querySelector(`#free-gift-item-${item.id}`);
              if (giftCartItem) {
                giftCartItem.checked = false;
              }
            });

            // Update current gift items in cart
            const objectKeysArray = Object.keys(updateItems);
            if (objectKeysArray.length || update_attribute) {
              const body = JSON.stringify({
                attributes: {
                  'free-gift': free_gift_attribute
                },
                updates: updateItems,
                sections: this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname
              });
              cart = await fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
              cart = await cart.json();
              sections = cart.sections;
            }

            // Add new gift items to cart
            if (add && currentGiftItem.length == 0) {
              const body = JSON.stringify({
                items: [
                  {
                    id: parseFloat(id),
                    quantity: 1,
                    properties: {
                      _free_gift: true
                    }
                  }
                ],
                sections: this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname
              });
              cart = await fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }});
              cart = await cart.json();
              sections = cart.sections;
            }

            // Update HTML
            if (objectKeysArray.length || ( add && currentGiftItem.length == 0)) {
              this.getSectionsToRender().forEach((section => {
                const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML = this.getSectionInnerHTML(sections[section.section], section.selector);
              }));
            }

            // Remove loader
            document.querySelector('cart-items').disableLoading();

            // Resolve
            resolve();

          })();

        } catch (error) {
          reject(error);
        }

      });

    }

  }

  window.FreeGift = FreeGift;

  customElements.define('free-gift', FreeGift);

}